// extracted by mini-css-extract-plugin
export default {"w-full":"Form_w-full__1a1EU","form":"Form_form__3k4Mb","input":"Form_input__3q8LU","result":"Form_result__q9YWK"};